import { useEffect } from 'react';
import { isParent } from '../utils/is-parent';

export const useOnOutsideClick = ({ refs, selectors, fn }) => {
  const onClick = (e) => {
    const selectorRefs = [...document.querySelectorAll(selectors)].map(
      (elem) => ({ current: elem }),
    );
    const arrayedRefs = Array.isArray(refs) ? refs : [refs];
    const combinedRefs = [...arrayedRefs, ...selectorRefs];
    const existingRefs = combinedRefs.filter((ref) => ref?.current);

    const someRefsExist = Boolean(existingRefs.length);
    const refsNotClicked = !existingRefs.some((ref) => {
      return isParent(e.target, ref?.current);
    });

    if (someRefsExist && refsNotClicked) {
      fn();
    }
  };

  useEffect(() => {
    document.addEventListener('mouseup', onClick);
    return () => {
      document.removeEventListener('mouseup', onClick);
    };
  }, []);
};
